import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgProps } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const formatDate = (d) =>
  new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export default function Journal() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/journal").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 pb-24 pt-40 lg:px-8 lg:pb-32" data-testid="journal-page">
      <Reveal>
        <p className="overline">The Journal</p>
        <h1 className="mt-4 max-w-2xl font-serif text-4xl font-light leading-tight text-[#262019] sm:text-5xl lg:text-6xl">
          Notes on <span className="italic text-[#A58343]">craft, care & diamonds</span>
        </h1>
      </Reveal>

      <div className="mt-20 grid gap-x-12 gap-y-20 md:grid-cols-2 lg:grid-cols-3" data-testid="journal-grid">
        {articles.map((a, i) => (
          <Reveal key={a.slug} delay={0.1 * i}>
            <Link to={`/journal/${a.slug}`} data-testid={`journal-article-${a.slug}`} className="group block">
              <div className="overflow-hidden bg-[#F4EEE3]">
                <img {...imgProps(a.image, "(max-width: 768px) 100vw, 33vw")} alt={a.title} loading="lazy" className="block h-auto w-full transition-opacity duration-500 group-hover:opacity-90" />
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-[10px] uppercase tracking-[0.25em] text-[#7C7163]">
                <span className="whitespace-nowrap">{formatDate(a.date)}</span>
                <span className="h-px w-6 bg-[#A58343]/40" />
                <span className="whitespace-nowrap">{a.read_time}</span>
              </div>
              <h2 className="mt-4 font-serif text-2xl font-medium leading-snug text-[#262019] transition-colors duration-300 group-hover:text-[#A58343]">
                {a.title}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-[#7C7163]">{a.excerpt}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
